/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { EmailDto } from '../model/emailDto';
import { SendEmailResponse } from '../model/sendEmailResponse';
import { SendSMSResponse } from '../model/sendSMSResponse';
import { SmsDto } from '../model/smsDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { MessagingServiceInterface }                            from './messaging.serviceInterface';


@Injectable()
export class MessagingService implements MessagingServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param body2 
     * @param body3 
     * @param body4 
     * @param body5 
     * @param body6 
     * @param body7 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendEmail(body?: string, body2?: string, body3?: string, body4?: string, body5?: Array<string>, body6?: string, body7?: string, observe?: 'body', reportProgress?: boolean): Observable<SendEmailResponse>;
    public sendEmail(body?: string, body2?: string, body3?: string, body4?: string, body5?: Array<string>, body6?: string, body7?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SendEmailResponse>>;
    public sendEmail(body?: string, body2?: string, body3?: string, body4?: string, body5?: Array<string>, body6?: string, body7?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SendEmailResponse>>;
    public sendEmail(body?: string, body2?: string, body3?: string, body4?: string, body5?: Array<string>, body6?: string, body7?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SendEmailResponse>(`${this.basePath}/messaging/not-used`,
            body7,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendEmailWitDto1(organization?: string, login?: string, body?: EmailDto, observe?: 'body', reportProgress?: boolean): Observable<SendEmailResponse>;
    public sendEmailWitDto1(organization?: string, login?: string, body?: EmailDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SendEmailResponse>>;
    public sendEmailWitDto1(organization?: string, login?: string, body?: EmailDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SendEmailResponse>>;
    public sendEmailWitDto1(organization?: string, login?: string, body?: EmailDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SendEmailResponse>(`${this.basePath}/messaging/email`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendSMSWithDto1(organization?: string, login?: string, body?: SmsDto, observe?: 'body', reportProgress?: boolean): Observable<SendSMSResponse>;
    public sendSMSWithDto1(organization?: string, login?: string, body?: SmsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SendSMSResponse>>;
    public sendSMSWithDto1(organization?: string, login?: string, body?: SmsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SendSMSResponse>>;
    public sendSMSWithDto1(organization?: string, login?: string, body?: SmsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SendSMSResponse>(`${this.basePath}/messaging/sms`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
